import {
    STORAGE_SET_ACCESS_TOKEN,
    STORAGE_CLEAR_ACCESS_TOKEN,
    STORAGE_UPDATE_CONFIRMATION_EMAIL_SENT_TIME
} from "../constants/persistStorage-constants";


export function setAccessToken(token) {
    return { type: STORAGE_SET_ACCESS_TOKEN, payload: token };
}

export function clearAccessToken() {
    return { type: STORAGE_CLEAR_ACCESS_TOKEN };
}

export function updateConfirmationSentEmailTime() {
    return { type: STORAGE_UPDATE_CONFIRMATION_EMAIL_SENT_TIME };
}
